import m from 'mithril'
import classNames from 'classnames'
import {
    Dialog
} from 'components'
import QuestionDialog from './dialogs/question'

class DashboardPage {
    constructor() {
        this.questions = [{
            order: "01",
            color: '#3e8e7f',
            answer: 0,
            isFinish: false,
            question: "一位CKD第四期病人，他的理想體重是60公斤，建議每日蛋白質攝取量為多少？",
            analysis: "(A) 36 ~ 48公克是對於CKD第四期、尚未透析的病人，為了延緩腎功能惡化，建議採行低蛋白飲食，標準為每日0.6-0.8g/kg。以理想體重60公斤計算：60 x 0.6 = 36克，60 x 0.8 = 48克。若能配合酮酸胺基酸使用，甚至可進一步以極低蛋白飲食（VLPD）作為標準（以蛋白攝取0.3~0.6g/kg計算），但需嚴格監測營養狀況。\n\n(B) 48 ~ 60 公克是CKD早期（Stage 1-2）或一般老年人的建議蛋白攝取量，以理想體重60公斤、蛋白攝取0.8-1.0 g/kg計算。對CKD第四期病人而言過高，無法延緩洗腎。\n\n(C) 60 ~ 72 公克是「透析病人」的建議量，以理想體重60公斤、蛋白攝取1.0-1.2 g/kg計算。因洗腎會流失蛋白質，與未洗腎者相反。\n\n(D) 18 ~ 36 公克是極低蛋白飲食（VLPD）的標準，以理想體重60公斤、蛋白攝取0.3~0.6 g/kg計算。若無搭配足量的酮酸胺基酸，會有營養不良風險，需嚴格監測營養狀況。",
            items: [{
                text: "36 ~ 48公克",
                analysis: "對於CKD第四期、尚未透析的病人，為了延緩腎功能惡化，建議採行低蛋白飲食，標準為每日0.6-0.8g/kg。以理想體重60公斤計算：60 x 0.6 = 36克，60 x 0.8 = 48克。若能配合酮酸胺基酸使用，甚至可進一步以極低蛋白飲食（VLPD）作為標準（以蛋白攝取0.3~0.6g/kg計算），但需嚴格監測營養狀況。"
            }, {
                text: "48 ~ 60 公克",
                analysis: "這是CKD早期（Stage 1-2）或一般老年人的建議蛋白攝取量，以理想體重60公斤、蛋白攝取0.8-1.0 g/kg計算。對CKD第四期病人而言過高，無法延緩洗腎。"
            }, {
                text: "60 ~ 72 公克",
                analysis: "這是「透析病人」的建議量，以理想體重60公斤、蛋白攝取1.0-1.2 g/kg計算。因洗腎會流失蛋白質，與未洗腎者相反。"
            }, {
                text: "18 ~ 36 公克",
                analysis: "這是極低蛋白飲食（VLPD）的標準，以理想體重60公斤、蛋白攝取0.3~0.6 g/kg計算。若無搭配足量的酮酸胺基酸，會有營養不良風險，需嚴格監測營養狀況。"
            }]
        }, {
            order: "02",
            color: '#3e8e7f',
            answer: 1,
            isFinish: false,
            question: "吉多利錠（Ketosteril）是藥品，吃多了會增加腎臟負擔，所以腎功能變更差時應該停藥？",
            analysis: "吉多利錠（Ketosteril）的設計初衷即是為了「降低」腎臟處理含氮廢物的負擔，並非一般會傷腎的藥物。它能有效降低身體的含氮廢物堆積，並改善尿毒症狀（如噁心、嘔吐）。\n\n在腎功能較差（如eGFR值為5~25 mL/min/1.73 m²）的階段，是最需要此藥物協助代謝廢物，不應隨意停藥。",
            items: [{
                text: "正確，因為吉多利錠含鈣，腎功能惡化時更容易造成鈣磷沉積，應立即停藥，改用純胺基酸製劑。",
                analysis: "吉多利錠（Ketosteril）的設計初衷即是為了「降低」腎臟處理含氮廢物的負擔，並非一般會傷腎的藥物。它能有效降低身體的含氮廢物堆積，並改善尿毒症狀（如噁心、嘔吐）。在腎功能較差（如eGFR值為5~25 mL/min/1.73 m²）的階段，是最需要此藥物協助代謝廢物，不應隨意停藥。"
            }, {
                text: "錯誤，吉多利錠並不會增加腎臟負擔，且不應隨意停藥。",
                analysis: "吉多利錠（Ketosteril）的設計初衷即是為了「降低」腎臟處理含氮廢物的負擔，並非一般會傷腎的藥物。它能有效降低身體的含氮廢物堆積，並改善尿毒症狀（如噁心、嘔吐）。在腎功能較差（如eGFR值為5~25 mL/min/1.73 m²）的階段，是最需要此藥物協助代謝廢物，不應隨意停藥。"
            }]
        }, {
            order: "03",
            color: '#3e8e7f',
            answer: 1,
            isFinish: false,
            question: "CKD病人問：「有吃吉多利錠（Ketosteril），是不是就可以不用低蛋白飲食了？」下列回答何者最正確？",
            analysis: "(A) 為錯誤選項！即使eGFR稍高，若放寬蛋白質攝取至1.0 g/kg，會失去低蛋白飲食延緩腎功能惡化的保護作用；且吉多利錠的設計前提就是須搭配限制蛋白的飲食。\n\n(B) 為正確選項！低蛋白飲食的目的是從源頭減少含氮廢物（尿毒素）的產生。吉多利錠則扮演轉化者的角色，能利用體內剩餘的含氮廢物轉化為必需胺基酸，進一步減輕腎臟負擔。若病患飲食不忌口，攝取過多蛋白質而產生大量廢物，藥物的轉化速度將趕不上廢物堆積的速度，因此兩者缺一不可，必須同步進行。\n\n(C) 為錯誤選項！藥物的轉化能力有限，無法依線性抵銷「吃到飽」產生的大量含氮廢物，且過量的藥物會導致高血鈣風險。\n\n(D) 為錯誤選項！這是運動營養學常見的誤區。對於未透析的CKD病人，即使有運動，蛋白質限制仍應維持在0.6-0.8 g/kg。若任意增加蛋白質攝取量，產生的含氮廢物會超過腎臟負荷，反而導致尿毒症狀惡化，進而降低運動耐受度。",
            items: [{
                text: "可以，若eGFR > 15 mL/min/1.73 m²，藥物轉化效能較佳，可適度放寬蛋白質限制至1.0 g/kg。",
                analysis: "不行！即使eGFR稍高，若放寬蛋白質攝取至1.0 g/kg，會失去低蛋白飲食延緩腎功能惡化的保護作用；且吉多利錠的設計前提就是須搭配限制蛋白的飲食。"
            }, {
                text: "不行，低蛋白飲食是減少毒素來源，而藥物是將毒素轉化為營養，兩者缺一不可。",
                analysis: "低蛋白飲食的目的是從源頭減少含氮廢物（尿毒素）的產生。吉多利錠則扮演轉化者的角色，能利用體內剩餘的含氮廢物轉化為必需胺基酸，進一步減輕腎臟負擔。若病患飲食不忌口，攝取過多蛋白質而產生大量廢物，藥物的轉化速度將趕不上廢物堆積的速度，因此兩者缺一不可，必須同步進行。"
            }, {
                text: "可以，但需依飲食比例調整藥物劑量，以代謝額外攝取肉類所產生的氮。",
                analysis: "不行！藥物的轉化能力有限，無法依線性抵銷「吃到飽」產生的大量含氮廢物，且過量的藥物會導致高血鈣風險。"
            }, {
                text: "不行，但若病人進行高強度的阻力運動，因身體合成代謝效率增加，可暫時恢復正常蛋白質飲食（1.0-1.2 g/kg）以避免肌肉流失。",
                analysis: "錯誤！這是運動營養學常見的誤區。對於未透析的CKD病人，即使有運動，蛋白質限制仍應維持在0.6-0.8 g/kg。若任意增加蛋白質攝取量，產生的含氮廢物會超過腎臟負荷，反而導致尿毒症狀惡化，進而降低運動耐受度。"
            }]
        }, {
            order: "04",
            color: '#3e8e7f',
            answer: 1,
            isFinish: false,
            question: "低蛋白飲食衛教時，為了節省時間，不需要詢問病人的「職業」，因為飲食原則大家都一樣。",
            analysis: "每個人的職業活動強度不同，所需的熱量也截然不同（例如建築工與行政人員的熱量消耗差異巨大）。若未評估職業而給予統一的飲食建議，可能導致勞力工作者熱量攝取不足，引發肌肉流失與營養不良。\n\n衛教必須客製化，確保病人在限制蛋白的同時，能攝取符合其生活型態的足夠熱量。",
            items: [{
                text: "正確，低蛋白飲食核心是「總量管制」，無論職業為何，蛋白質攝取上限皆固定為0.6 g/kg。",
                analysis: "每個人的職業活動強度不同，所需的熱量也截然不同（例如建築工與行政人員的熱量消耗差異巨大）。若未評估職業而給予統一的飲食建議，可能導致勞力工作者熱量攝取不足，引發肌肉流失與營養不良。衛教必須客製化，確保病人在限制蛋白的同時，能攝取符合其生活型態的足夠熱量。"
            }, {
                text: "錯誤，飲食衛教會因病人的職業不同而有所調整。",
                analysis: "每個人的職業活動強度不同，所需的熱量也截然不同（例如建築工與行政人員的熱量消耗差異巨大）。若未評估職業而給予統一的飲食建議，可能導致勞力工作者熱量攝取不足，引發肌肉流失與營養不良。衛教必須客製化，確保病人在限制蛋白的同時，能攝取符合其生活型態的足夠熱量。"
            }]
        }, {
            order: "05",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "一位理想體重66公斤的CKD病人，eGFR值為28 mL/min/1.73 m²，一天的熱量需求大約落在以下哪個區間？",
            analysis: "(A) 為錯誤選項！此計算方式為理想體重x（20 ~ 25 大卡/公斤），這是一般減重時的熱量計算，會導致CKD病人的肌肉流失（PEW）。\n\n(B) 為錯誤選項！此計算方式為理想體重x（25 ~ 30 大卡/公斤）。但KDOQI建議即使是代謝能力較低的老年人，仍應盡量維持30 大卡/公斤以上的熱量攝取。\n\n(C) 為正確選項！慢性腎臟病病人的熱量需求計算公式：理想體重x（30 ~ 35 大卡/公斤）。以66公斤為例，低標為66 x 30 = 1980大卡，高標為66 x 35 = 2310大卡。攝取足夠熱量是預防身體組織分解、避免尿毒素上升的關鍵，絕對不能因為限制蛋白而忽略熱量補充。\n\n(D) 為錯誤選項！此計算方式為理想體重x（40 ~ 45 大卡/公斤），這是重症感染或燒傷病人的需求，對CKD病人會造成代謝負擔與肥胖。",
            items: [{
                text: "1320 ~ 1650 大卡",
                analysis: "此計算方式為理想體重x（20 ~ 25 大卡/公斤），這是一般減重時的熱量計算，會導致CKD病人的肌肉流失（PEW）。"
            }, {
                text: "1650 ~ 1980 大卡",
                analysis: "此計算方式為理想體重x（25 ~ 30 大卡/公斤）。但KDOQI建議即使是代謝能力較低的老年人，仍應盡量維持30 大卡/公斤以上的熱量攝取。"
            }, {
                text: "1980 ~ 2310 大卡",
                analysis: "慢性腎臟病病人的熱量需求計算公式：理想體重x（30 ~ 35 大卡/公斤）。以66公斤為例，低標為66 x 30 = 1980大卡，高標為66 x 35 = 2310大卡。攝取足夠熱量是預防身體組織分解、避免尿毒素上升的關鍵，絕對不能因為限制蛋白而忽略熱量補充。"
            }, {
                text: "2640 ~ 2970 大卡",
                analysis: "此計算方式為理想體重x（40 ~ 45 大卡/公斤），這是重症感染或燒傷病人的需求，對CKD病人會造成代謝負擔與肥胖。"
            }]
        }, {
            order: "06",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "下列哪一組水果屬於「高鉀」水果，血鉀高的CKD病人需注意？",
            analysis: "(A) 鳳梨、蓮霧、山竹皆屬於低鉀水果。每份鉀含量通常低於200mg，是適合CKD病人適量食用的安全名單。\n\n(B) 蘋果、葡萄、水梨皆屬於典型的低鉀水果。在標準份量下，它們的鉀含量相對較低，是臨床上常建議血鉀偏高的CKD病人可優先選擇的安全名單。\n\n(C) 香蕉、番茄、奇異果、哈密瓜、草莓等水果，鉀離子的含量均較高。慢性腎臟病病人若血鉀過高，可能引發嚴重的心律不整甚至猝死。進行衛教時應提供具體的清單，並建議病人選擇低鉀水果（如蘋果、葡萄、鳳梨等），或透過將水果切小塊、適量食用的方式來控制攝取量。\n\n(D) 檸檬通常僅作調味，鉀的總攝取量低；芒果屬於中高鉀含量的水果；西瓜雖然鉀含量不算很高，但容易因攝取量過大而導致鉀負荷過量。",
            items: [{
                text: "鳳梨、蓮霧、山竹",
                analysis: "鳳梨、蓮霧、山竹皆屬於低鉀水果。每份鉀含量通常低於200mg，是適合CKD病人適量食用的安全名單。"
            }, {
                text: "蘋果、葡萄、水梨",
                analysis: "蘋果、葡萄、水梨皆屬於典型的低鉀水果。在標準份量下，它們的鉀含量相對較低，是臨床上常建議血鉀偏高的CKD病人可優先選擇的安全名單。"
            }, {
                text: "哈密瓜、香蕉、奇異果",
                analysis: "香蕉、番茄、奇異果、哈密瓜、草莓等水果，鉀離子的含量均較高。慢性腎臟病病人若血鉀過高，可能引發嚴重的心律不整甚至猝死。進行衛教時應提供具體的清單，並建議病人選擇低鉀水果（如蘋果、葡萄、鳳梨等），或透過將水果切小塊、適量食用的方式來控制攝取量。"
            }, {
                text: "西瓜、檸檬、芒果",
                analysis: "檸檬通常僅作調味，鉀的總攝取量低；芒果屬於中高鉀含量的水果；西瓜雖然鉀含量不算很高，但容易因攝取量過大而導致鉀負荷過量。"
            }]
        }, {
            order: "07",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "吉多利錠（Ketosteril）的主要功能與機轉，下列敘述何者正確？",
            analysis: "(A) 為錯誤選項！BCAA主要用於肝臟相關疾病或運動補給，雖然吉多利錠含有部分BCAA結構的酮酸，但抑制肌肉分解非其核心功能。\n\n(B) 為錯誤選項！雖然吉多利錠的鈣鹽成分會結合部分的磷，但只是附加價值，並非其主要藥理分類。\n\n(C) 為正確選項！吉多利錠（Ketosteril）是一種「酮酸胺基酸」，其結構不含「氮」，進入人體後會與代謝產生的含氮廢物結合。透過轉氨作用（Transamination），它能將有毒的含氮廢物轉化為人體所需的必需胺基酸。這不僅能「廢物利用」減少尿毒素堆積，還能補充低蛋白飲食下可能缺乏的營養，達到保護腎臟與維持營養的雙重效果。\n\n(D) 為錯誤選項！吉多利錠不是直接補充白蛋白，而是提供原料讓身體合成蛋白質。",
            items: [{
                text: "它是一種支鏈胺基酸（BCAA），主要用於抑制肌肉蛋白分解。",
                analysis: "BCAA主要用於肝臟相關疾病或運動補給，雖然吉多利錠含有部分BCAA結構的酮酸，但抑制肌肉分解非其核心功能。"
            }, {
                text: "它屬於含鈣的磷結合劑，主要機轉為結合腸胃道中的磷，無營養補充功能。",
                analysis: "雖然其鈣鹽成分會結合部分的磷，但只是附加價值，並非其主要藥理分類。"
            }, {
                text: "它是一種酮酸胺基酸，能將含氮廢物轉化為必需胺基酸，降低腎臟負擔。",
                analysis: "吉多利錠（Ketosteril）是一種「酮酸胺基酸」，其結構不含「氮」，進入人體後會與代謝產生的含氮廢物結合。透過轉氨作用（Transamination），它能將有毒的含氮廢物轉化為人體所需的必需胺基酸。這不僅能「廢物利用」減少尿毒素堆積，還能補充低蛋白飲食下可能缺乏的營養，達到保護腎臟與維持營養的雙重效果。"
            }, {
                text: "它是高濃度白蛋白濃縮製劑，可直接提升血清白蛋白濃度，改善營養不良。",
                analysis: "此藥不是直接補充白蛋白，而是提供原料讓身體合成蛋白質。"
            }]
        }, {
            order: "08",
            color: '#3e8e7f',
            answer: 1,
            isFinish: false,
            question: "為了控制血磷，應建議CKD病人多吃「糙米飯」或「五穀米」取代白飯，比較健康？",
            analysis: "雖然糙米與五穀米對一般大眾是健康食物，但全穀類保留了外殼與胚芽，其磷與鉀的含量遠高於精緻白米。對於慢性腎臟病病人而言，攝取過多全穀類容易導致血磷與血鉀失控。\n\n因此在CKD飲食原則中，會建議「以白米代替糙米」來減少礦物質的攝取負擔。",
            items: [{
                text: "正確，糙米富含維生素B群與膳食纖維，有助於改善尿毒引起的便秘與神經病變。",
                analysis: "雖然糙米與五穀米對一般大眾是健康食物，但全穀類保留了外殼與胚芽，其磷與鉀的含量遠高於精緻白米。對於慢性腎臟病病人而言，攝取過多全穀類容易導致血磷與血鉀失控。因此在CKD飲食原則中，會建議「以白米代替糙米」來減少礦物質的攝取負擔。"
            }, {
                text: "錯誤，攝取過多的糙米與五榖米容易導致血磷與血鉀失控。",
                analysis: "雖然糙米與五穀米對一般大眾是健康食物，但全穀類保留了外殼與胚芽，其磷與鉀的含量遠高於精緻白米。對於慢性腎臟病病人而言，攝取過多全穀類容易導致血磷與血鉀失控。因此在CKD飲食原則中，會建議「以白米代替糙米」來減少礦物質的攝取負擔。"
            }]
        }, {
            order: "09",
            color: '#3e8e7f',
            answer: 0,
            isFinish: false,
            question: "醫師說要「低蛋白飲食」，病人卻只吃汆燙青菜不敢吃肉，這樣會有什麼後果？",
            analysis: "(A) 為正確選項！慢性腎臟病病人極度需要「充足的熱量」來維持生理運作，若熱量攝取不足，身體會啟動「異化作用」分解自身的肌肉組織來產生能量。肌肉分解的過程會釋放大量含氮廢物，反而導致尿毒素上升（BUN升高），加重腎臟負擔。因此，不敢吃肉且熱量不足，反而會加速腎功能惡化與營養不良（PEW）。\n\n(B) 為錯誤選項！即使白蛋白尚可，若熱量不足造成的肌肉流失是隱形的，長期會導致肌少症與惡病質（Cachexia）。\n\n(C) 為錯誤選項！VLPD定義需嚴格限制蛋白至0.3~0.6 g/kg，且「必須」搭配酮酸胺基酸，單純吃青菜（植物性蛋白生物價低）且未補酮酸，會導致必需胺基酸缺乏。\n\n(D) 為錯誤選項！免疫球蛋白不足是營養不良的後果之一，但對腎臟本身的影響並非「無影響」，營養不良本身就是慢性腎臟病的獨立危險因子。",
            items: [{
                text: "熱量不足，導致身體分解肌肉蛋白質，反而製造更多尿毒素傷腎。",
                analysis: "慢性腎臟病病人極度需要「充足的熱量」來維持生理運作，若熱量攝取不足，身體會啟動「異化作用」分解自身的肌肉組織來產生能量。肌肉分解的過程會釋放大量含氮廢物，反而導致尿毒素上升（BUN升高），加重腎臟負擔。因此，不敢吃肉且熱量不足，反而會加速腎功能惡化與營養不良（PEW）。"
            }, {
                text: "只要血清白蛋白（Albumin）維持在3.5 g/dL以上，單純攝取蔬食可有效降低尿毒素生成。",
                analysis: "即使白蛋白尚可，若熱量不足造成的肌肉流失是隱形的，長期會導致肌少症與惡病質（Cachexia）。"
            }, {
                text: "這是標準的極低蛋白飲食（VLPD），額外補充足夠的水溶性維生素即可。",
                analysis: "VLPD定義需嚴格限制蛋白至0.3~0.6 g/kg，且「必須」搭配酮酸胺基酸，單純吃青菜（植物性蛋白生物價低）且未補酮酸，會導致必需胺基酸缺乏。"
            }, {
                text: "長期缺乏動物性蛋白質會導致免疫球蛋白不足，但對腎功能本身不會有太大影響。",
                analysis: "這是營養不良的後果之一，但對腎臟本身的影響並非「無影響」，營養不良本身就是慢性腎臟病的獨立危險因子。"
            }]
        }, {
            order: "10",
            color: '#3e8e7f',
            answer: 0,
            isFinish: false,
            question: "針對合併高血壓的CKD病人，烹調時不建議使用市售的「低鈉鹽」或「薄鹽醬油」。請問此敘述是否正確？",
            analysis: "市售的「低鈉鹽」或「薄鹽醬油」，多半是利用「氯化鉀」來取代氯化鈉以降低鹹度。對於慢性腎臟病病人而言，排鉀能力本就較差，使用這類調味品極易造成高血鉀症，引發心律不整風險。因此建議使用一般鹽減量使用，或利用蔥、薑、蒜、檸檬等天然辛香料來提味即可。",
            items: [{
                text: "正確，建議合併高血壓的慢性腎臟病病人在使用一般的鹽時，減量即可。",
                analysis: "市售的「低鈉鹽」或「薄鹽醬油」，多半是利用「氯化鉀」來取代氯化鈉以降低鹹度。對於慢性腎臟病病人而言，排鉀能力本就較差，使用這類調味品極易造成高血鉀症，引發心律不整風險。因此建議使用一般鹽減量使用，或利用蔥、薑、蒜、檸檬等天然辛香料來提味即可。"
            }, {
                text: "錯誤，低鈉鹽的鈉含量減半，能有效降低RAAS系統活性，建議合併高血壓的慢性腎臟病病人都使用這類型調味料。",
                analysis: "市售的「低鈉鹽」或「薄鹽醬油」，多半是利用「氯化鉀」來取代氯化鈉以降低鹹度。對於慢性腎臟病病人而言，排鉀能力本就較差，使-*用這類調味品極易造成高血鉀症，引發心律不整風險。因此建議使用一般鹽減量使用，或利用蔥、薑、蒜、檸檬等天然辛香料來提味即可。"
            }]
        }, {
            order: "11",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "當病人的eGFR值介於15~29 mL/min/1.73 m²時，屬於慢性腎臟病的第幾期？",
            analysis: "(A) 為錯誤選項！Stage 3A的eGFR範圍為45~59 mL/min/1.73 m²。\n\n(B) 為錯誤選項！Stage 3B的eGFR範圍為30~44 mL/min/1.73 m²。\n\n(C) 為正確選項！依據KDIGO與台灣臨床指引，CKD Stage 4的eGFR範圍為15~29 mL/min/1.73 m²。此階段腎功能已嚴重衰退，體內毒素開始明顯堆積，是延緩進入透析治療的關鍵時期。此時通常已建議開始嚴格實施低蛋白飲食，並視情況搭配酮酸胺基酸治療。\n\n(D) 為錯誤選項！Stage 5的eGFR < 15 mL/min/1.73 m²，為慢性腎臟病末期，須進行透析或移植的準備。",
            items: [{
                text: "第三期A（Stage 3A）",
                analysis: "Stage 3A的eGFR範圍為45~59 mL/min/1.73 m²。"
            }, {
                text: "第三期B（Stage 3B）",
                analysis: "Stage 3B的eGFR範圍為30~44 mL/min/1.73 m²。"
            }, {
                text: "第四期（Stage 4）",
                analysis: "依據KDIGO與台灣臨床指引，CKD Stage 4的eGFR範圍為15~29 mL/min/1.73 m²。此階段腎功能已嚴重衰退，體內毒素開始明顯堆積，是延緩進入透析治療的關鍵時期。此時通常已建議開始嚴格實施低蛋白飲食，並視情況搭配酮酸胺基酸治療。"
            }, {
                text: "第五期（Stage 5）",
                analysis: "Stage 5的eGFR < 15 mL/min/1.73 m²，為慢性腎臟病末期，須進行透析或移植的準備。"
            }]
        }, {
            order: "12",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "下列哪一組食物全部屬於「高磷」食物，CKD病人應避免或謹慎食用？",
            analysis: "(A) 非全數皆應避免。糙米飯的含磷量高於白米飯，應避免食用；低脂牛奶屬於高磷飲品，應避免飲用；但雞胸肉屬於高生理價蛋白質，雖然含有磷，但在低蛋白飲食計算份量內是「必須食用」的營養來源。\n\n(B) 非全數皆應避免。碳酸飲料因含有無機磷，應完全避免；蛋黃的磷含量極高，建議少吃；但深綠色蔬菜（如菠菜）雖然磷含量高，但人體吸收率低，因此並不需要刻意避免。\n\n(C) 動物性鮮奶油主要成分為脂肪，磷含量很低；燕麥奶常含有磷酸鹽添加劑，須謹慎飲用；板豆腐雖然含有磷，但人體吸收率低，且為優質植物蛋白，是推薦的食材。\n\n(D) 內臟類（如豬肝、雞心）、堅果類，以及加工肉品（如火腿、香腸）皆屬於高磷食物。長期高血磷會導致血管鈣化與骨病變，因此是臨床上最優先建議避免的類別。",
            items: [{
                text: "糙米飯、低脂牛奶、雞胸肉",
                analysis: "此選項非全數皆應避免。糙米飯的含磷量高於白米飯，應避免食用；低脂牛奶屬於高磷飲品，應避免飲用；但雞胸肉屬於高生理價蛋白質，雖然含有磷，但在低蛋白飲食計算份量內是「必須食用」的營養來源。"
            }, {
                text: "碳酸飲料、蛋黃、深綠色蔬菜",
                analysis: "此選項非全數皆應避免。碳酸飲料因含有無機磷，應完全避免；蛋黃的磷含量極高，建議少吃；但深綠色蔬菜（如菠菜）雖然磷含量高，但人體吸收率低，因此並不需要刻意避免。"
            }, {
                text: "動物性鮮奶油、燕麥奶、板豆腐",
                analysis: "動物性鮮奶油主要成分為脂肪，磷含量很低；燕麥奶常含有磷酸鹽添加劑，須謹慎飲用；板豆腐雖然含有磷，但人體吸收率低，且為優質植物蛋白，是推薦的食材。"
            }, {
                text: "內臟、堅果、火腿",
                analysis: "內臟類（如豬肝、雞心）、堅果類，以及加工肉品（如火腿、香腸）皆屬於高磷食物。長期高血磷會導致血管鈣化與骨病變，因此是臨床上最優先建議避免的類別。"
            }]
        }, {
            order: "13",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "關於CKD病人不能吃「楊桃」，主要原因是什麼？",
            analysis: "(A) 為錯誤選項！雖然楊桃含草酸，但其致死原因並非急性結石。\n\n(B) 為錯誤選項！楊桃的鉀含量雖然不低，但其他水果的含鉀量更高。「鉀」並非楊桃被「絕對禁食」的關鍵原因。\n\n(C) 為錯誤選項！抑制CYP3A4酵素是葡萄柚的特性，會影響鈣離子阻斷劑代謝，與楊桃無關。\n\n(D) 為正確選項！楊桃中含有一種獨特的神經毒素（Caramboxin），正常腎臟可將其排出，但慢性腎臟病病人因排毒功能下降，毒素會堆積在體內。這可能引起打嗝、肢體麻木、躁動不安等神經症狀，嚴重時甚至會導致癲癇、昏迷或死亡，因此建議病人應完全避免食用。",
            items: [{
                text: "楊桃屬於高草酸食物，易導致急性腎小管阻塞與結石，故不建議食用。",
                analysis: "雖然楊桃含草酸，但其致死原因並非急性結石。"
            }, {
                text: "楊桃富含鉀離子，對於服用RAAS抑制劑的病人，會引發嚴重高血鉀症。",
                analysis: "楊桃的鉀含量雖然不低，但其他水果的含鉀量更高。「鉀」並非楊桃被「絕對禁食」的關鍵原因。"
            }, {
                text: "楊桃會抑制CYP3A4 酵素，干擾鈣離子阻斷劑代謝，導致低血壓休克。",
                analysis: "抑制CYP3A4酵素是葡萄柚的特性，會影響鈣離子阻斷劑代謝，與楊桃無關。"
            }, {
                text: "楊桃含有CKD病人無法代謝的神經毒素，可能導致昏迷或死亡。",
                analysis: "楊桃中含有一種獨特的神經毒素（Caramboxin），正常腎臟可將其排出，但慢性腎臟病病人因排毒功能下降，毒素會堆積在體內。這可能引起打嗝、肢體麻木、躁動不安等神經症狀，嚴重時甚至會導致癲癇、昏迷或死亡，因此建議病人應完全避免食用。"
            }]
        }, {
            order: "14",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "關於「磷」的吸收率，下列哪種來源的磷吸收率最高（幾乎100%），最需要嚴格限制？",
            analysis: "(A) 植物性磷（如豆類）因與植酸結合，人體缺乏植酸酶，吸收率最低（約10-30%），是相對安全的磷來源。\n\n(B) 動物性磷吸收率次之（約40-60%）。\n\n(C) 乳製品（如牛奶、起司）中的磷大多會與酪蛋白結合，其腸道吸收率屬於中高程度，約為60-80%。\n\n(D) 最危險的是加工食品、食品添加物中的「無機磷」，其人體吸收率高達100%，對血磷的影響最大。因此，衛教重點應放在避免「加工食品」與「含磷飲料」，而非過度限制天然植物性的食物。",
            items: [{
                text: "植物性磷（全穀類、豆類）",
                analysis: "植物性磷（如豆類）因與植酸結合，人體缺乏植酸酶，吸收率最低（約10-30%），是相對安全的磷來源。"
            }, {
                text: "動物性磷（紅肉類）",
                analysis: "動物性磷吸收率約40-60%。"
            }, {
                text: "食品添加物（無機磷）",
                analysis: "磷的來源影響吸收率：植物性磷（如豆類）因與植酸結合，人體缺乏植酸酶，吸收率最低（約10-30%）；動物性磷吸收率次之（約40-60%）。最危險的是加工食品、食品添加物中的「無機磷」，其人體吸收率高達100%，對血磷的影響最大。因此，衛教重點應放在避免「加工食品」與「含磷飲料」，而非過度限制天然植物性的食物。"
            }, {
                text: "乳製品中的磷（酪蛋白磷）",
                analysis: "乳製品（如牛奶、起司）中的磷大多會與酪蛋白結合，其腸道吸收率屬於中高程度，約為60-80%。"
            }]
        }, {
            order: "15",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "病患有水腫與高血壓，關於飲食建議，下列何者「錯誤」？",
            analysis: "(A) (B) (C) 皆為正確建議！\n\n(D) 為錯誤建議！對於腎功能不全且合併水腫的病人，必須限制水分攝取，原則為「前一日尿量 + 500~700mL的水量」。若每日強迫喝2000mL水分，會超過腎臟排水能力，加重水腫、高血壓甚至引發肺積水。同時應減少湯汁類攝取，並以乾飯取代稀飯來控制隱形水分。",
            items: [{
                text: "建議多利用天然辛香料（如蔥、薑、蒜、檸檬）來取代鹽與醬油。",
                analysis: "此為正確建議！"
            }, {
                text: "少喝湯，以乾飯取代稀飯。",
                analysis: "此為正確建議！"
            }, {
                text: "避免吃醃製品與罐頭。",
                analysis: "此為正確建議！"
            }, {
                text: "為了消水腫，每天至少要喝2000cc的水。",
                analysis: "對於腎功能不全且合併水腫的病人，必須限制水分攝取，原則為「前一日尿量 + 500~700mL的水量」。若每日強迫喝2000mL水分，會超過腎臟排水能力，加重水腫、高血壓甚至引發肺積水。同時應減少湯汁類攝取，並以乾飯取代稀飯來控制隱形水分。"
            }]
        }, {
            order: "16",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "慢性腎臟病常見的合併症，不包含下列何者？",
            analysis: "CKD常見合併症包括腎性貧血（因紅血球生成素不足所導致）、礦物質骨病變（鈣磷失衡）、心血管疾病、高血壓及高血脂等。\n\n肝硬化屬於肝臟疾病，並非CKD的直接併發症。了解合併症有助於全面評估其健康狀況，而非只看腎功能指數。",
            items: [{
                text: "慢性腎臟病-礦物質與骨病變（CKD-MBD）",
                analysis: "礦物質骨病變是典型併發症。"
            }, {
                text: "心血管疾病（CVD）與異位性鈣化",
                analysis: "心血管疾病是 CKD 最主要死因。"
            }, {
                text: "肝硬化",
                analysis: "CKD常見合併症包括腎性貧血（因紅血球生成素不足）、礦物質骨病變（鈣磷失衡）、心血管疾病、高血壓及高血脂等。肝硬化屬於肝臟疾病，並非CKD的直接併發症。了解合併症有助於全面評估其健康狀況，而非只看腎功能指數。"
            }, {
                text: "腎性貧血（Renal Anemia）",
                analysis: "腎性貧血非常常見，為紅血球生成素（Erythropoietin, EPO）不足導致。"
            }]
        }, {
            order: "17",
            color: '#3e8e7f',
            answer: 0,
            isFinish: false,
            question: "烹調低蛋白飲食時，為了補充足夠熱量，下列建議何者最正確？",
            analysis: "(A) 為正確建議！低蛋白飲食減少了肉類來源的熱量，因此必須增加「油脂」與「醣類（低氮澱粉）」的比例來補足缺口。建議利用煎、炒等烹調方式增加油脂攝取，這能有效提升熱量密度。但為了保護心血管，應避免飽和脂肪酸較高的動物性油脂（如豬油、牛油），改選用植物油為佳。\n\n(B) 堅果本身屬於高磷高鉀食物，CKD應限制堅果原型攝取，雖然堅果油可以使用，但「大量攝取堅果」是錯誤建議。\n\n(C) 中鏈脂肪酸（MCT）雖然易於吸收，但口感不佳、易導致腹瀉；因其烹調發煙點低，較適合用於涼拌或低溫烹調，不適用於油炸、燉煮等料理方式，非首選常規建議。\n\n(D) 為錯誤建議！市售的高蛋白飲品是設計給老年人或透析病人使用的。未透析的CKD病人必須限制蛋白，應建議選擇「低蛋白、高熱量」專用配方的補充品。",
            items: [{
                text: "以煎、炒方式烹調，增加油脂攝取，但避免動物性油脂。",
                analysis: "低蛋白飲食減少了肉類來源的熱量，因此必須增加「油脂」與「醣類（低氮澱粉）」的比例來補足缺口。建議利用煎、炒等烹調方式增加油脂攝取，這能有效提升熱量密度。但為了保護心血管，應避免飽和脂肪酸較高的動物性油脂（如豬油、牛油），改選用植物油為佳。"
            }, {
                text: "建議改用多元不飽和脂肪酸豐富的堅果油拌飯，並大量攝取堅果以補充礦物質。",
                analysis: "堅果本身屬於高磷高鉀食物，CKD應限制堅果原型攝取，雖然堅果油可以使用，但「大量攝取堅果」是錯誤建議。"
            }, {
                text: "多攝取中鏈脂肪酸（MCT），因其不需膽鹽乳化，可增量添加而不增加血脂負擔。",
                analysis: "中鏈脂肪酸（MCT）雖然易於吸收，但口感不佳、易導致腹瀉；因其烹調發煙點低，較適合用於涼拌或低溫烹調，不適用於油炸、燉煮等料理方式，非首選常規建議。"
            }, {
                text: "若發現CKD病人食慾不佳，應建議購買市售高蛋白營養補充品，以預防肌少症與體力衰退。",
                analysis: "錯誤！市售的高蛋白飲品是設計給老年人或透析病人使用的。未透析的CKD病人必須限制蛋白，應建議選擇「低蛋白、高熱量」專用配方的補充品。"
            }]
        }, {
            order: "18",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "關於CKD病人的運動建議，下列何者正確？",
            analysis: "(A) 集中運動易造成受傷及血壓波動，規律且分散的運動對心血管保護較佳。\n\n(B) 適度阻力運動可預防肌少症，對慢性腎臟病至關重要。\n\n(C) 最大心率90%是高強度無氧區間，對共病多的CKD病人風險過高，一般建議為中等強度（約最大心率的60-70%）。\n\n(D) 根據KDIGO 2024年指引：建議CKD病人進行與心血管健康及耐受度相符的運動（目標為每週至少150分鐘的中等強度運動，或是達到與其心血管及身體耐受度相符合的水準）。",
            items: [{
                text: "CKD病人因骨質疏鬆風險高，應完全避免負重或阻力運動，僅建議床上伸展。",
                analysis: "適度阻力運動可預防肌少症，對慢性腎臟病至關重要。"
            }, {
                text: "建議集中在週末兩天進行高強度運動，總時數達標即可，以利身體在週間進行修復。",
                analysis: "集中運動易造成受傷及血壓波動，規律且分散的運動對心血管保護較佳。"
            }, {
                text: "運動強度應達到最大心率的90%以上，才能有效刺激腎臟血流灌注。",
                analysis: "最大心率90%是高強度無氧區間，對共病多的CKD病人風險過高，一般建議為中等強度（約最大心率的60-70%）。"
            }, {
                text: "每週至少運動5天，每天累積30分鐘以上。",
                analysis: "根據KDIGO 2024年指引：建議CKD病人進行與心血管健康及耐受度相符的運動（目標為每週至少150分鐘的中等強度運動，或是達到與其心血管及身體耐受度相符合的水準）。"
            }]
        }, {
            order: "19",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "吉多利錠（Ketosteril）使用期間，最需要監測哪種電解質異常？",
            analysis: "(A) 為錯誤選項！吉多利錠代謝後偏鹼性（消耗氫離子），有助於矯正酸中毒，而非導致酸中毒。\n\n(B) 為錯誤選項！吉多利錠本身不含利尿劑成分，不直接影響鉀離子排泄。\n\n(C) 為錯誤選項！吉多利錠含鈣，會結合磷，反而是導致「低血磷」或幫助降磷，不會直接導致高血磷。\n\n(D) 為正確選項！吉多利錠的成分為酮酸鈣鹽，每錠含有約50毫克的鈣質。長期服用可能會導致血鈣濃度上升，引發高血鈣症。因此，在用藥期間必須定期監測血清鈣濃度，並適時調整鈣片或維生素D的劑量，以避免鈣磷乘積過高導致血管鈣化。",
            items: [{
                text: "代謝性酸中毒",
                analysis: "藥物代謝後偏鹼性（消耗氫離子），有助於矯正酸中毒，而非導致酸中毒。"
            }, {
                text: "低血鉀",
                analysis: "藥物本身不含利尿劑成分，不直接影響鉀離子排泄。"
            }, {
                text: "高血磷",
                analysis: "藥物含鈣會結合磷，反而是導致「低血磷」或幫助降磷，不會直接導致高血磷。"
            }, {
                text: "高血鈣",
                analysis: "吉多利錠的成分為酮酸鈣鹽，每錠含有約50毫克的鈣質。長期服用可能會導致血鈣濃度上升，引發高血鈣症。因此，在用藥期間必須定期監測血清鈣濃度，並適時調整鈣片或維生素D的劑量，以避免鈣磷乘積過高導致血管鈣化。"
            }]
        }, {
            order: "20",
            color: '#3e8e7f',
            answer: 0,
            isFinish: false,
            question: "下列哪種食材，雖然是植物，但屬於「高蛋白」食物，執行低蛋白飲食的CKD病人在計算份量時不能忽略？",
            analysis: "(A) 黃豆、黑豆、毛豆及其製品（如豆腐、豆漿）屬於「高生理價蛋白質」，其蛋白質含量豐富，等同於肉類。許多病人誤以為植物性食物就可以多吃，這會導致蛋白質攝取超標。在進行低蛋白飲食計算時，必須與肉類、蛋類合併計算，嚴格控制總量。\n\n(B) 雖然四季豆、豌豆莢為豆科植物，但歸類為蔬菜類，蛋白質不高。\n\n(C) 蒟蒻、寒天幾乎無熱量與蛋白，屬低蛋白點心。\n\n(D) 玉米、南瓜屬於全穀雜糧類，含「低生理價蛋白」，需計入總量但非高蛋白來源。",
            items: [{
                text: "黃豆、黑豆",
                analysis: "黃豆、黑豆、毛豆及其製品（如豆腐、豆漿）屬於「高生理價蛋白質」，其蛋白質含量豐富，等同於肉類。許多病人誤以為植物性食物就可以多吃，這會導致蛋白質攝取超標。在進行低蛋白飲食計算時，必須與肉類、蛋類合併計算，嚴格控制總量。"
            }, {
                text: "四季豆、豌豆莢",
                analysis: "雖然四季豆、豌豆莢為豆科植物，但歸類為蔬菜類，蛋白質不高。"
            }, {
                text: "蒟蒻、寒天",
                analysis: "蒟蒻、寒天幾乎無熱量與蛋白，屬低蛋白點心。"
            }, {
                text: "玉米、南瓜",
                analysis: "玉米、南瓜屬於全穀雜糧類，含「低生理價蛋白」，需計入總量但非高蛋白來源。"
            }]
        }, {
            order: "21",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "關於吉多利錠（Ketosteril）健保給付規範，下列何者錯誤？",
            analysis: "(A) (B) (D) 皆為正確的吉多利錠（Ketosteril）健保給付規範內容。\n\n(C) 為錯誤選項！一旦健保給付後，當腎絲球過濾率（eGFR）進步時，並不需要停藥，健保仍會給付直到eGFR值 ≧ 25 mL/min/1.73 m2。",
            items: [{
                text: "限慢性腎衰竭病患行低蛋白飲食治療，連續三個月，每個月之腎絲球過濾率（eGFR） ≦ 15 mL/min/1.73 m2且尚未接受透析治療，每日至多使用六顆。",
                analysis: "此為正確的健保給付規範內容。"
            }, {
                text: "使用時應每兩個月檢查一次，腎絲球過濾率（eGFR） ≧ 25mL/min/1.73 m2時，或服用本品期間病人若發生體重減輕>5%或血清白蛋白降低>5%之情況或病人不遵守低蛋白飲食時，應即停藥。",
                analysis: "此為正確的健保給付規範內容。"
            }, {
                text: "當腎絲球過濾率（eGFR） > 15 mL/min/1.73 m2時，應該停藥，避免被健保核刪。",
                analysis: "一旦健保給付後，當腎絲球過濾率（eGFR）進步時，並不需要停藥，健保仍會給付直到eGFR值 ≧ 25 mL/min/1.73 m2。"
            }, {
                text: "本品不得用於透析及換腎病人，並不得做為一般營養補充劑。",
                analysis: "此為正確的健保給付規範內容。"
            }]
        }, {
            order: "22",
            color: '#3e8e7f',
            answer: 2,
            isFinish: false,
            question: "病人的eGFR值只有18 mL/min/1.73 m²，這代表的意思是？",
            analysis: "(A) Stage 2的eGFR範圍為60~89 mL/min/1.73 m²。\n\n(B) Stage 3A的eGFR範圍為45~59 mL/min/1.73 m²。\n\n(C) 正常eGFR值約為100-120 mL/min/1.73 m²，eGFR值為20 mL/min/1.73 m² 代表腎臟過濾毒素的功能僅剩正常的1/5左右。依據分期標準，eGFR範圍為15~29 mL/min/1.73 m² 屬於第四期（重度慢性腎臟病）。此時病人雖然尚未需要進行透析，但必須積極進行飲食控制與藥物治療，以延緩進入第五期（末期腎病變）的時間。\n\n(D) Stage 5的eGFR < 15 mL/min/1.73 m²，eGFR值18 mL/min/1.73 m² 雖然嚴重，但仍有藥物治療延緩惡化的空間。",
            items: [{
                text: "腎功能輕度異常（Stage 2），仍可逆轉。",
                analysis: "Stage 2的eGFR範圍為60~89 mL/min/1.73 m²。"
            }, {
                text: "腎功能中度衰退（Stage 3A），需每半年追蹤。",
                analysis: "Stage 3A的eGFR範圍為45~59 mL/min/1.73 m²。"
            }, {
                text: "腎臟功能嚴重衰退（Stage 4），需積極控制與治療。",
                analysis: "正常eGFR值約為100-120 mL/min/1.73 m²，eGFR值為20 mL/min/1.73 m² 代表腎臟過濾毒素的功能僅剩正常的1/5左右。依據分期標準，eGFR範圍為15~29 mL/min/1.73 m² 屬於第四期（重度慢性腎臟病）。此時病人雖然尚未需要進行透析，但必須積極進行飲食控制與藥物治療，以延緩進入第五期（末期腎病變）的時間。"
            }, {
                text: "末期腎臟病變（Stage 5），需立即準備透析。",
                analysis: "Stage 5的eGFR < 15 mL/min/1.73 m²，eGFR值18 mL/min/1.73 m² 雖然嚴重，但仍有藥物治療延緩惡化的空間。"
            }]
        }, {
            order: "23",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "CKD病人的營養評估及診斷，並不包含以下何者？",
            analysis: "(A) (B) (C) 皆為健保 Pre-ESRD 照護計畫中，營養師必須評估的必要項目，以預防蛋白質能量耗損（PEW）、確認病人是否落實低蛋白飲食原則、協助病人控制血壓及預防慢性腎臟病礦物質與骨病變（CKD-MBD）。\n\n(D) Pre-ESRD之病人照護與衛教計畫並未包含保健食品選購推薦。",
            items: [{
                text: "熱量攝取",
                analysis: "此為健保 Pre-ESRD 照護計畫中，營養師必須評估的必要項目之一，以預防蛋白質能量耗損（PEW）。"
            }, {
                text: "蛋白質攝取",
                analysis: "此為健保 Pre-ESRD 照護計畫中，營養師必須評估的必要項目之一，需確認病人是否落實低蛋白飲食原則。"
            }, {
                text: "磷攝取（全穀／堅果／調味料）、鈉攝取（加工醃漬品／湯汁）",
                analysis: "此為健保 Pre-ESRD 照護計畫中，營養師必須評估的必要項目之一，以協助病人控制血壓及預防慢性腎臟病礦物質與骨病變（CKD-MBD）。"
            }, {
                text: "保健食品選購推薦",
                analysis: "Pre-ESRD之病人照護與衛教計畫並未包含保健食品選購推薦。"
            }]
        }, {
            order: "24",
            color: '#3e8e7f',
            answer: 3,
            isFinish: false,
            question: "關於低蛋白飲食的「蔬菜」選擇，為了避免高鉀，下列處理方式何者正確？",
            analysis: "鉀離子是水溶性的礦物質，容易溶於水中。對於需要限鉀的CKD病人，建議將蔬菜切段後汆燙，讓鉀離子溶出至湯水中，撈起青菜後再淋上油或調味。\n\n此外，(A) 根莖類煮湯、(B) 生菜沙拉或 (C) 蔬菜精力湯 因含鉀量極高，應盡量避免食用。",
            items: [{
                text: "選擇鉀含量低的根莖類蔬菜（如地瓜、馬鈴薯）煮湯食用。",
                analysis: "根莖類煮湯後，鉀會溶於湯中，喝湯等於喝下所有鉀，且根莖類（如馬鈴薯）本身鉀含量就高。"
            }, {
                text: "建議改吃生菜沙拉，以保留維生素C與植化素，避免加熱破壞營養。",
                analysis: "生菜沙拉未經烹煮，鉀離子完整保留，是高鉀地雷。"
            }, {
                text: "將蔬菜打成精力湯直接飲用。",
                analysis: "蔬菜精力湯濃縮了大量蔬果的鉀離子，極度危險。"
            }, {
                text: "蔬菜用熱水汆燙後，將菜湯瀝乾再食用。",
                analysis: "鉀離子是水溶性的礦物質，容易溶於水中。對於需要限鉀的CKD病人，建議將蔬菜切段後汆燙，讓鉀離子溶出至湯水中，撈起青菜後再淋上油或調味。此外，菜湯、蔬菜精力湯或生菜沙拉因含鉀量極高，應盡量避免食用。"
            }]
        }, {
            order: "25",
            color: '#3e8e7f',
            answer: 1,
            isFinish: false,
            question: "在低蛋白飲食搭配吉多利錠時，理想體重60公斤的成年CKD病人，一天建議吃幾份「豆魚蛋肉類」？",
            analysis: "(A) 0~1份太少，會導致必需胺基酸不足。\n\n(B) 雖然總蛋白質有限制，但扣除米飯、蔬菜中含有的「低生理價蛋白」後，剩餘能分配給「高生理價蛋白」（豆魚蛋肉類）的額度約剩2~4份。這需要精確的計算，以確保攝取的每一份蛋白質都是高品質的，能被身體有效利用修補組織。\n\n(C) 4~6份是正常人的份量，對於CKD第四期病人而言已超標。\n\n(D) 蛋白質攝取應相對固定，因活動量最主要消耗的不是蛋白質。且6份蛋白質對CKD第四期病人而言已超標。",
            items: [{
                text: "0~1份",
                analysis: "0~1份太少，會導致必需胺基酸不足。"
            }, {
                text: "2~4份",
                analysis: "雖然總蛋白質有限制，但扣除米飯、蔬菜中含有的「低生理價蛋白」後，剩餘能分配給「高生理價蛋白」（豆魚蛋肉類）的額度約剩2~4份。這需要精確的計算，以確保攝取的每一份蛋白質都是高品質的，能被身體有效利用修補組織。"
            }, {
                text: "4~6份",
                analysis: "4~6份是正常人的份量，對於CKD第四期病人而言已超標。"
            }, {
                text: "視當天活動量而定，若有運動可增加至6份以便修補肌肉。",
                analysis: "蛋白質攝取應相對固定，因活動量最主要消耗的不是蛋白質。且6份蛋白質對CKD第四期病人而言已超標。"
            }]
        }]
        const questionColors = ['#157cec', '#1356a4', '#0f67c3', '#e2d552', '#ddc017']
        this.questions = this.questions.map((question) => ({
            ...question,
            color: questionColors[Math.floor(Math.random() * questionColors.length)]
        }))
    }
    oncreate(vnode) {

    }

    view() {
        return [
            m(".container", [
                m(".row.no-gutters.w-100.px-5", [
                    m(".col-md-12.py-3", [
                        m(".d-flex.justify-content-between", [
                            m("img.img-fluid", {
                                src: `./img/logo1.png`,
                                maxWidth: "250px",
                                maxHeight: "80px"
                            }),
                            m(".d-flex.align-items-center", [
                                m(".btn.btn-outline-dark", {
                                    style: {
                                        color: "#1884c6",
                                        fontSize: "1.5rem",
                                        textShadow: "1px 0 #1884c6",
                                        borderRadius: "15px"
                                    },
                                    onclick: (e) => {
                                        e.preventDefault()
                                        this.questions.map((_question) => {
                                            _question.isFinish = false
                                            _question.selectedOptions = []
                                        })
                                    }
                                }, "RESTART")
                            ])
                        ])
                    ]),
                ]),
                m(".row.no-gutters.w-100.row-cols-5.px-5", [
                    this.questions.map((_question, index) => {
                        return [
                            m(".col.pt-2.pb-2", {
                                style: {
                                    cursor: "pointer"
                                },
                                class: classNames({
                                    'pr-2': index % 5 == 0,
                                    'px-1': index % 5 == 1 || index % 5 == 2 || index % 5 == 3,
                                    'pl-2': index % 5 == 4,
                                }),
                                onclick: (e) => {
                                    e.preventDefault()
                                    if (!_question.isFinish) {
                                        Dialog.show(QuestionDialog, {
                                            attrs: {
                                                model: _question
                                            },
                                        })
                                    }
                                }
                            }, [
                                m(".p-3.d-flex.justify-content-center.align-items-center.flex-column", {
                                    style: {
                                        background: (_question.isFinish) ? "#eeeeef" : _question.color,
                                        borderRadius: "30px",
                                        minHeight: "14vh"
                                    }
                                }, [
                                    m("span.font-weight-bold", {
                                        style: {
                                            color: (_question.isFinish) ? "#2ca6e0" : "#FFFFFF",
                                            fontSize: "2rem",
                                            fontWeight: 700
                                        }
                                    }, "BINGO"),
                                    m("span.font-weight-bold", {
                                        style: {
                                            textShadow: (_question.isFinish) ? "1px 0 #2ca6e0" : "1px 0 #FFFFFF",
                                            color: (_question.isFinish) ? "#2ca6e0" : "#FFFFFF",
                                            fontSize: "5rem",
                                            lineHeight: "4.25rem",
                                            fontWeight: 700
                                        }
                                    }, _question.order),

                                ])
                            ])
                        ]
                    })

                ])

            ]),
            m(Dialog),
        ]
    }
}

export default DashboardPage
